import { Tooltip } from "antd";
import { ReactNode } from "react";
import { TOOLTIP_MESSAGES } from "./constants";
import { isMobile } from "react-device-detect";

interface SharedTooltipProps {
  title?: string | JSX.Element;
  children: ReactNode;
  show?: boolean;
}

export const SharedTooltip = ({
  title = TOOLTIP_MESSAGES.DEVELOPMENT,
  children,
  show = true,
}: SharedTooltipProps) => {
  if (!show || !title) {
    return <>{children}</>;
  }

  return (
    <Tooltip
      title={title}
      placement={isMobile ? "top" : "right"}
      overlayInnerStyle={{ padding: "4px 8px" }}
      overlayStyle={{ marginLeft: -8 }}
      mouseEnterDelay={0.1}
    >
      {children}
    </Tooltip>
  );
};
